import { Text } from '@atoms/index';
import texts from '@components/ContactUs/en.json'

const ContactHeading = () => {
    return (
        <div>
            <Text
                content={texts?.contactUsHeaderHeading}
                className="h5-semibold md:h4-semibold lg:h3-semibold text-primary-500"
                htmlTag='h1'
            />
            <Text
                content={texts?.contactUsHeaderDescription}
                className="p5-regular md:p4-regular text-gray-800"
            />
        </div>
    );
};

export default ContactHeading;
